var _link, _style, _style2, _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 610,
    height: 145,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "dark-mode-native-style"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 2v46H54v23H35.58c-.077.666-.14 1.333-.205 2-1.151 12.531 1.036 24.088 6.063 33.969L43.124 110c1.011 1.817 2.191 3.523 3.438 5.188 1.244 1.662 1.685 2.582 2.468 3.687C62.32 133.811 82.13 141 105 141c50.648 0 93.633-22.438 112.656-72.844C231.153 69.541 244.1 66.08 250 54.562c-9.399-5.423-21.478-3.685-28.438-.187L240 2l-72 46h-23V2z",
    id: "path10"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.82 113.24l-.042-25.557-.127-45.657m25.854 19.676l-25.727 25.981 25.854 25.643M321.285 88.022c.125-5.481-1.469-11.082-4.696-15.614-4.652-6.532-12.18-10.99-20.438-11.087-.55 0-1.096 0-1.65.042-3.265.202-6.427.656-9.225 1.82-18.4 7.656-21.66 33.208-6.136 44.769 13.445 10.011 33.002 5.923 39.776-9.352 1.431-3.228 2.37-7.297 2.37-10.578V41.814m124.151 22.554c-3.81-2.462-8.255-3.35-12.652-3.343-.477 0-.967.024-1.396.042-12.713.547-24.5 9.53-24.5 26.955 0 20.6 22.088 31.718 38.59 22.003m74.135-2.243c13.002-11.137 39.056-33.47 39.056-33.47s-.95-1.797-1.565-2.624c-5.258-7.055-13.29-10.578-21.75-10.578-20.909 0-36.582 27.036-15.74 46.672 1.442 1.36 3.424 2.425 5.627 3.343 7.647 3.188 18.116 2.927 23.78-1.27M364.02 61.196c-.593.01-1.182.073-1.777.084-15.855.291-27.286 16.76-23.823 32.032 3.375 14.883 19.634 23.696 33.682 18.83 16.359-4.29 23.03-24.889 14.048-38.803-4.912-7.61-13.239-12.313-22.13-12.144zm240.726.507c-6.42.017-12.672 2.266-17.306 6.601-7.308 6.031-8.895 13.647-8.802 23.273l.212 21.877",
    id: "path12",
    fill: "none",
    stroke: "#394d54",
    strokeWidth: 10.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.488 45.732h22.866v23.375h11.561c5.34 0 10.831-.951 15.887-2.665 2.485-.842 5.274-2.014 7.724-3.489-3.228-4.214-4.876-9.536-5.36-14.781-.66-7.134.78-16.42 5.608-22.004l2.404-2.78 2.864 2.302c7.211 5.794 13.276 13.89 14.345 23.118 8.683-2.554 18.878-1.95 26.532 2.468l3.14 1.811-1.653 3.226C246.933 68.947 233.4 72.86 220.17 72.167c-19.797 49.309-62.898 72.653-115.157 72.653-27 0-51.77-10.093-65.876-34.047-.827-1.488-1.535-3.044-2.286-4.572-4.768-10.544-6.352-22.095-5.278-33.637l.323-3.457H51.45V45.732h22.866V22.866h45.732V0h27.44v45.732",
    id: "path14",
    fill: "#394d54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -22.866)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.859 3.811h19.818v19.817h-19.818z",
    id: "path22",
    fill: "#00acd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.859 26.676h19.818v19.819h-19.818z",
    id: "path24",
    fill: "#20c2ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.292 21.977V5.46m2.972 16.516V5.46m3.002 16.516V5.46m3.003 16.516V5.46m3.003 16.516V5.46m2.972 16.516V5.46",
    id: "path26",
    stroke: "#394d54",
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 22.866)",
    id: "use28",
    xlinkHref: "#path26"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1 0 0 -1 22.866 4.573)",
    id: "use30",
    xlinkHref: "#g20"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(-91.464 45.732)",
    id: "use32",
    xlinkHref: "#g18"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(-45.732 45.732)",
    id: "use34",
    xlinkHref: "#g18"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 45.732)",
    id: "use36",
    xlinkHref: "#g18"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.57 54.38c1.533-11.916-7.384-21.275-12.914-25.719-6.373 7.368-7.363 26.678 2.635 34.808-5.58 4.956-17.337 9.448-29.376 9.448H34C32.83 85.484 34 146 34 146h217l-.987-91.424c-9.398-5.424-21.484-3.694-28.443-.197",
    clipPath: "url(#clipPath8)",
    id: "path38",
    fill: "#17b5eb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89v57h217V89",
    clipPath: "url(#clipPath8)",
    id: "path40",
    fillOpacity: 0.17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.237 140.89c-13.54-6.425-20.971-15.16-25.106-24.694L45 118l21 28 45.237-5.11",
    clipPath: "url(#clipPath8)",
    id: "path42",
    fill: "#d4edf1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 53.938v.03c-20.861 26.89-50.783 50.38-82.906 62.72-28.655 11.007-53.639 11.06-70.875 2.218-1.856-1.048-3.676-2.211-5.5-3.312-12.637-8.832-19.755-23.442-19.157-42.688H34V146h217V50h-25z",
    clipPath: "url(#clipPath8)",
    id: "path44",
    fillOpacity: 0.085
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.625 117.031c14.165.776 29.282.915 42.469-3.219",
    id: "path46",
    fill: "none",
    stroke: "#394d54",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.17 106.96a5.467 5.467 0 11-10.933-.001 5.467 5.467 0 0110.933 0z",
    id: "path48",
    fill: "#d4edf1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.121 103.308a1.598 1.598 0 00.798 2.98c.605 0 1.13-.335 1.402-.831a3.915 3.915 0 11-2.2-2.15z",
    id: "path50",
    fill: "#394d54"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.162h254.327c-5.537-1.404-17.52-3.302-15.544-10.56-10.07 11.652-34.353 8.175-40.482 2.43-6.824 9.898-46.554 6.135-49.325-1.576-8.556 10.041-35.067 10.041-43.623 0-2.773 7.711-42.502 11.474-49.327 1.575-6.128 5.746-30.41 9.223-40.48-2.428C17.522 86.86 5.539 88.758 0 90.163",
    id: "path52",
    fill: "#394d54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.a47babe245c6329c7b43c90e4a49fc1a.svg";
export { ForwardRef as ReactComponent };